/* eslint-disable @typescript-eslint/no-var-requires */
import {ConfigurationApplication} from '@application/Config';
import {getAuth} from '@infra/api/authManager/authManager';
import {proxy} from '@infra/api/fetch/proxy';
import {Environment} from '@domain/model/Config/Configuration';
import {bootstrap, SentryEnvironment, KameleoonEnvironment} from '@lookiero/style-profile';
import {version} from '@lookiero/style-profile/package.json';
import {PROJECT_ID} from './sentryConfig';
import {Path} from '../routing/routes.definition';

const configuration = ConfigurationApplication.retrieve();

const sentry = (): SentryEnvironment => ({
  publicKey: 'bf9ded71e97254c526526bf5cc878aa1',
  release: `style-profile@${version}`,
  project: PROJECT_ID,
  environment: configuration.environment === Environment.DEVELOPMENT ? 'development' : 'production',
});

const KAMELEOON_DEV = {
  siteCode: 'aplm4v3ckn',
  experiment: {},
} as KameleoonEnvironment;

const KAMELEOON_PROD = {
  siteCode: '0zj7mtr4bm',
  experiment: {},
} as KameleoonEnvironment;

const kameleoon = (): KameleoonEnvironment =>
  ConfigurationApplication.retrieve().environment === Environment.DEVELOPMENT ? KAMELEOON_DEV : KAMELEOON_PROD;

const {root, nextBestActionRoot} = bootstrap({
  apiUrl: () => proxy('/style-profile/api'),
  getAuthToken: getAuth as unknown as () => Promise<string>,
  sentry,
  kameleoon,
  basePath: Path.STYLE_PROFILE_HOME,
});

export {root, nextBestActionRoot};
